import * as types from '../actions/types'
import emailReducer from './email'
import passwordReducer from './password'
import { validateEmail, validatePassword } from '../../utils/validations'

export const initState = {
  email: undefined,
  password: undefined,
  isFormValid: false,
  showFormValidationResult: false,
  formValidationMessage: '',
}

const loginForm = (state = initState, action) => {
  switch (action.type) {
    case types.UPDATE_CUSTOMER_LOGIN_EMAIL_FIELD:
      return {
        ...state,
        email: emailReducer(state.email, action),
        showFormValidationResult: false,
      }
    case types.UPDATE_CUSTOMER_LOGIN_PASSWORD_FIELD:
      return {
        ...state,
        password: passwordReducer(state.password, action),
        showFormValidationResult: false,
      }
    case types.RUN_CUSTOMER_LOGIN_FORM_VALIDATIONS: {
      const email = validateEmail(state.email.value)
      const password = validatePassword(state.password.value)
      return {
        ...state,
        email,
        password,
        isFormValid: email.isValid && password.isValid,
        showFormValidationResult: true,
      }
    }
    case types.SHOW_CUSTOMER_LOGIN_FORM_VALIDATION_MESSAGE:
      return {
        ...state,
        isFormValid: action.success,
        showFormValidationResult: true,
        formValidationMessage: action.message,
      }
    case types.RESET_FORM_FEILDS:
      return {
        email: emailReducer('', action),
        password: passwordReducer('', action),
        isFormValid: false,
        showFormValidationResult: false,
        formValidationMessage: '',
      }
    default:
      return {
        ...state,
        isFormValid: false,
        showFormValidationResult: false,
        formValidationMessage: '',
        email: emailReducer(state.email, action),
        password: passwordReducer(state.password, action),
      }
  }
}

export default loginForm
